import React, {useEffect} from 'react';
import {NavLink} from "react-router-dom";

const About = () => {
  useEffect(() => {
    if (document.getElementById('mobile-menu').classList.contains("flex")) {
      document.getElementById('mobile-menu').classList.replace("flex", "hidden");
    }
  }, [])

  return (
    <div className="mx-4 md:mx-10 lg:mx-24 mt-6 md:mt-10 lg:mt-12">
      <p className="text-xl md:text-3xl mr-2 md:mr-64 mb-12">
        Hi, I'm Malachy Williams, from Nigeria.
        I love to code, I am a fullstack developer,
        coding in HTML, CSS, JavaScript.
        <br/>
        <br/>
        I also write Java, ReactJS, VueJS, NodeJS.
        I use frameworks such as SpringBoot for java
        and ExpressJS for NodeJs
        <br/>
        <br/>
        I use databases such as NoSQL like MongoDb and Redis and
        SQL databases such as MySQL and PostgreSQL
        <br/>
        <br/>
        I specialize in creating rich UI and responsive web design
        for users and bringing
        a new dimension to how coding goes,
        <br/>
        <br/>
        Want to work with me, <NavLink exact to="/contact"><span className="underline text-blue-400">Click here</span></NavLink>
      </p>
    </div>
  );
};

export default About;